module.exports = __webpack_public_path__ + "static/img/suanfas_banner@2x.06f3e302.jpg";